module.exports = __webpack_public_path__ + "static/img/aluminium_board_type.88a3de17.png";